import { render, staticRenderFns } from "./CustomerBriefcaseRowTable.vue?vue&type=template&id=7d0abfa7&scoped=true&"
import script from "./CustomerBriefcaseRowTable.vue?vue&type=script&lang=js&"
export * from "./CustomerBriefcaseRowTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBriefcaseRowTable.vue?vue&type=style&index=0&id=7d0abfa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0abfa7",
  null
  
)

export default component.exports